import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@devhop/ui";
import { config } from "@/shared/lib/config";
import logo from "../../../../assets/favicon_io/favicon.ico";
import SignInForm from "../ui/SignInForm";

export function LoginPage() {
  return (
    <Card className="w-full">
      <CardHeader className="space-y-4">
        <div className="flex items-center gap-3">
          <img src={logo} alt="Logo" className="h-8 w-8 rounded" />
          <h1 className="font-medium text-lg">{config.brandName}</h1>
        </div>
        <div className="space-y-2">
          <CardTitle className="font-medium text-xl">ເຂົ້າລະບົບ</CardTitle>
          <CardDescription className="text-muted-foreground text-sm">
            ໃສ່ອີເມວ ແລະ ລະຫັດຜ່ານເພື່ອເຂົ້າໃຊ້ບັນຊີຂອງທ່ານ
          </CardDescription>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <SignInForm />
      </CardContent>
    </Card>
  );
}
